import httpClient from '@/http-client'

export const store = data => {
  return httpClient
    .post('/api/health-categories', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const get = (Options = {}) => {
  return httpClient
    .get('/api/health-categories', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = data => {
  return httpClient
    .put(`/api/health-categories/${data.health_category_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/health-categories/${id}`)
    .then(response => Promise.resolve(response.data))
}
export default {
  store,
  get,
  update,
  destroy
}
